import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { CurrentUser } from '../api/auth';

const AUTH_CSRF_STORAGE_KEY = 'crowpeaks-auth-csrf';

interface AuthState {
  token: string | null;
  csrfToken: string | null;
  user: CurrentUser | null;
  hasHydrated: boolean;
  setToken: (token: string) => void;
  setCsrfToken: (csrfToken: string) => void;
  setUser: (user: CurrentUser | null) => void;
  clearSession: () => void;
  setHasHydrated: (value: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      csrfToken: null,
      user: null,
      hasHydrated: false,
      setToken: (token: string) => set({ token }),
      setCsrfToken: (csrfToken: string) => set({ csrfToken }),
      setUser: (user: CurrentUser | null) => set({ user }),
      clearSession: () => set({ token: null, csrfToken: null, user: null }),
      setHasHydrated: (value: boolean) => set({ hasHydrated: value }),
    }),
    {
      name: AUTH_CSRF_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ csrfToken: state.csrfToken }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
